<template>
  <div class="page-card">
    <el-card>
      <div slot="header">轮播图管理</div>
      <el-button type="success" size="small" @click="openEdit()">新增轮播图</el-button>
      <el-table :data="list" border stripe style="margin-top: 12px;">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="图片" width="120">
          <template slot-scope="scope">
            <img v-if="scope.row.image" :src="scope.row.image" style="width: 100px; height: 50px; object-fit: cover;" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" />
        <el-table-column prop="description" label="描述" />
        <el-table-column prop="order" label="排序" width="80" />
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="editForm.id ? '编辑轮播图' : '新增轮播图'" :visible.sync="editVisible" width="600px">
        <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="80px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="editForm.title" />
          </el-form-item>
          <el-form-item label="图片" prop="image">
            <el-upload
              :key="uploadKey"
              class="avatar-uploader"
              action=""
              list-type="picture-card"
              :file-list="imageFileList"
              :limit="1"
              :auto-upload="true"
              :before-upload="beforeImageUpload"
              :http-request="uploadBannerImage"
              :on-exceed="handleImageExceed"
              :on-remove="handleImageRemove"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">建议尺寸 750x320，支持 png/jpg/jpeg/webp/gif，单张不超过 5MB</div>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="editForm.description" placeholder="选填" />
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="editForm.order" :min="0" :max="9999" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request, {
  resolveUploadedFileUrl,
  pickUploadResponsePayload,
  normalizeMediaUrl
} from '@/api/request'

export default {
  name: 'BannerList',
  data() {
    return {
      list: [],
      editVisible: false,
      uploadKey: 0,
      editForm: {
        id: null,
        title: '',
        image: '',
        description: '',
        order: 0
      },
      imageFileList: [],
      editRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        image: [
          {
            validator: (rule, value, callback) => {
              const hasList = this.imageFileList && this.imageFileList.length > 0
              const hasImage = this.editForm.image
              if (hasList || hasImage) {
                callback()
              } else {
                callback(new Error('请上传轮播图图片'))
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      request.get('/banners').then(res => {
        const data = res.data || res
        this.list = (data && data.items) || []
      })
    },
    openEdit(row) {
      if (row && row.id) {
        const imgRaw = (row.image || '').trim()
        const img = normalizeMediaUrl(imgRaw) || imgRaw
        this.editForm = { ...row, image: img }
        this.imageFileList = img ? [{ name: 'image', url: img }] : []
      } else {
        this.editForm = {
          id: null,
          title: '',
          image: '',
          description: '',
          order: 0
        }
        this.imageFileList = []
      }
      this.uploadKey += 1
      this.editVisible = true
    },
    save() {
      if (this.imageFileList && this.imageFileList.length > 0 && this.imageFileList[0].url && !this.editForm.image) {
        this.editForm.image = this.imageFileList[0].url
      }
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const data = { ...this.editForm }
        const req = data.id
          ? request.put(`/banners/${data.id}`, data)
          : request.post('/banners', data)
        req.then(() => {
          this.$message.success('保存成功')
          this.editVisible = false
          this.fetchList()
        })
      })
    },
    remove(row) {
      this.$confirm('确认删除该轮播图吗？', '提示', { type: 'warning' }).then(() => {
        request.delete(`/banners/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    },
    beforeImageUpload(file) {
      const okType = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'].includes(file.type)
      if (!okType) {
        this.$message.error('仅支持 png/jpg/jpeg/webp/gif')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    uploadBannerImage(req) {
      const form = new FormData()
      form.append('file', req.file)
      request
        .post('/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(res => {
          const data = pickUploadResponsePayload(res)
          const url = resolveUploadedFileUrl(data)
          if (!url) throw new Error('empty url')
          this.imageFileList = [{ name: req.file.name || 'image', url }]
          this.editForm.image = url
          req.onSuccess && req.onSuccess({ url })
        })
        .catch(err => {
          this.$message.error('图片上传失败')
          req.onError && req.onError(err)
        })
    },
    handleImageExceed() {
      this.$message.warning('只能上传 1 张轮播图')
    },
    handleImageRemove(file, fileList) {
      this.imageFileList = fileList
      this.editForm.image = fileList.length ? fileList[0].url : ''
    }
  }
}
</script>

<style scoped>
.upload-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 6px;
}
</style>

